<h1>{{ title | translate }}</h1>
<obg-m-iaui-verification-container (done)="onDone($event)"></obg-m-iaui-verification-container>
